<template>
  <div class="se-die-game">
    <se-die-card
      :game="game"
      :game-data="gameData"
      :disallow-betting="disallowBetting"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :showDrawingAnimation="showDrawingAnimation"
      :draw-result="drawResult"
    />
    <se-die-result
      :game="game"
      :game-data="gameData"
      :disallow-betting="disallowBetting"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :draw-result="drawResult"
    />
    <div
      ref="se-die-disallow-betting-section"
      class="se-die-disallow-betting-section"
      v-if="displayDisallowSection"
    >
      <Row
        class="se-die-disallow-betting"
        type="flex"
        justify="center"
        align="middle"
      >
        <Col>
          <div>{{ $t("general.no_more_bet") }}</div>
        </Col>
      </Row>
    </div>
    <div ref="se-die-animation-section" class="se-die-animation-section">
      <!-- <canvas ref="canvas-animation" class="canvas-animation"></canvas> -->
    </div>
  </div>
</template>

<script>
import { TweenLite, TimelineLite, TweenMax } from "gsap";
import { random } from "lodash";
import { Row, Button, Timeline } from "iview";
// import * as PIXI from "pixi.js";
// import * as PIXI from "pixi.js";
// window.PIXI = PIXI;
// global.PIXI = PIXI;
// require("pixi-spine");
// import "pixi.js";
// import "pixi-spine";

import SeDieCard from "./se-die-game/SeDieCard";
import SeDieResult from "./se-die-game/SeDieResult";
import EventBus from "../../configs/event-bus";

export default {
  props: [
    "game",
    "gameData",
    "countDown",
    "drawResult",
    "showDrawingAnimation",
    "disallowBetting",
    "displayDisallowSection",
    "minutesString",
    "secondsString",
    "onAnimationEnd",
  ],
  components: {
    SeDieResult,
    SeDieCard,
    Row,
    Button,
  },
  data() {
    return {
      isAnimationRunning: false,
    };
  },
  watch: {
    showDrawingAnimation(newVal, oldVal) {
      if (newVal) {
        this.isAnimationRunning = true;
      }
    },
    drawResult(newVal, oldVal) {
      let vm = this;
      if (newVal && this.isAnimationRunning) {
        TweenLite.set(vm.$refs["se-die-animation-section"], {
          display: "block",
        });

        let resultRedZero = ["set0"];
        let resultRedOne = ["set1", "set2", "set4", "set8"];
        let resultRedTwo = ["set3", "set5", "set6", "set9", "set10", "set12"];
        let resultRedThree = ["set7", "set11", "set13", "set14"];
        let resultRedFour = ["set15"];
        let result = null;

        //define set Chips for animation
        if (this.drawResult["0W4R"] !== "0") {
          result = resultRedFour[0];
        } else if (this.drawResult["1W3R"] !== "0") {
          result = resultRedThree[random(3)];
        } else if (this.drawResult["2W2R"] !== "0") {
          result = resultRedTwo[random(5)];
        } else if (this.drawResult["3W1R"] !== "0") {
          result = resultRedOne[random(3)];
        } else if (this.drawResult["4W0R"] !== "0") {
          result = resultRedZero[0];
        }

        let pixiCanvas = new PIXI.Application({
          width: this.$refs["se-die-animation-section"].offsetWidth,
          height: this.$refs["se-die-animation-section"].offsetHeight,
          transparent: true,
        });
        this.$refs["se-die-animation-section"].appendChild(pixiCanvas.view);

        pixiCanvas.loader
          .add("bowl", "img/sedie/spine_XocDia_lottery.json")
          .load(onAssetsLoaded);

        pixiCanvas.stage.interactive = true;
        let bowl = null;

        function onAssetsLoaded(loader, res) {
          // instantiate the spine animation
          bowl = new PIXI.spine.Spine(res.bowl.spineData);

          // create a container for the spine animation and add the animation to it
          let bowlContainer = new PIXI.Container();
          bowlContainer.addChild(bowl);

          // measure the spine animation and position it inside its container to align it to the origin
          let localRect = bowl.getLocalBounds();
          // console.log(bowl.getLocalBounds());
          bowl.position.set(-localRect.x, -localRect.y);

          // now we can scale, position and rotate the container as any other display object
          let scale = Math.min(
            (pixiCanvas.screen.width * 0.7) / bowlContainer.width,
            (pixiCanvas.screen.height * 0.7) / bowlContainer.height
          );
          bowlContainer.scale.set(scale, scale);

          bowlContainer.position.set(
            (pixiCanvas.screen.width - bowlContainer.width) * 0.5,
            (pixiCanvas.screen.height - bowlContainer.height) * 0.5
          );

          let animation = ["shake", "open", "idle"];

          // once position and scaled, set the animation to play
          bowl.state.setAnimation(0, "idle", true);
          pixiCanvas.stage.addChild(bowlContainer);

          setTimeout(() => {
            bowl.state.setAnimation(0, animation[0], true);
            bowl.state.addAnimation(1, result, true);
            setTimeout(() => {
              bowl.state.setAnimation(0, animation[1], false);
              setTimeout(() => {
                bowl.state.addAnimation(1, "idle", true);
                setTimeout(() => {
                  // pixiCanvas.clearBeforeRender = true;
                  pixiCanvas.destroy(true);

                  TweenLite.set(vm.$refs["se-die-animation-section"], {
                    clearProps: "all",
                  });
                  clearStakeRecord(vm.gameData.gID);
                  EventBus.$emit("update-session-storage");
                  vm.animationEnd();
                }, 1000);
              }, 2000);
            }, 2000);
          }, 1000);
        }
      }
    },
  },
  mounted() {
    EventBus.$emit("update-session-storage");
  },
  methods: {
    animationEnd() {
      this.$emit("on-animation-end");
    },
  },
};
</script>

<style lang="scss" scoped>
.se-die-game {
  position: relative;
  height: 373px;
  background: #e2e7f0;
}

.se-die-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.se-die-disallow-betting,
.se-die-stop-animation {
  width: 100%;
  height: 100%;
}
.se-die-animation-section {
  display: none;
  position: absolute;
  top: 0px;
  background: rgba(#000000, 0.9);
  width: 100%;
  height: 100%;
}
.canvas-animation {
  // width: 100%;
  // height: 100%;
  background: #182841;
}
</style>
